import { useRouter } from "next/navigation";
import { useCallback } from "react";

import { logout as logoutApi } from "@/api/auth";
import { useAuthStore } from "@/stores/use-auth-store";

export const useLogout = (redirectTo = "/") => {
  const router = useRouter();
  const { setAuthenticated, cleanSession } = useAuthStore();

  const logout = useCallback(async () => {
    try {
      await logoutApi();
      setAuthenticated(false);
      cleanSession();
      router.push(redirectTo);
    } catch (error) {
      // Fail-safe: limpar sessão mesmo se a chamada falhar
      setAuthenticated(false);
      cleanSession();
      router.push(redirectTo);
    }
  }, [setAuthenticated, cleanSession, redirectTo, router]);

  return logout;
};
